const PAGE_SIZE_OPTIONS = [5, 10, 20, 50, 100]
const COLUMN_OPTIONS = [1,2,3,4,5]
const GALLERY_PAGE_SIZE_OPTIONS = [[1, 2, 3, 4, 5],
  [2, 4, 6, 8, 10],
  [3, 6, 9, 12, 15],
  [4, 8, 12, 16, 20],
  [5, 10, 15, 20, 25]
]

export default {
  PAGE_SIZE_OPTIONS,
  COLUMN_OPTIONS,
  GALLERY_PAGE_SIZE_OPTIONS
}
